module.exports = __webpack_public_path__ + "gb-wls.e8cf2e67dc6d552124ef.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/gb-wls.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/gb-wls.svg
// module chunks = styles